














































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';
//@ts-ignore
import FuncionesHeader from '@/components/headersSelect/funciones'


//@ts-ignore
import poa_funciones from '@/mixins/axios/poa_funciones'
//@ts-ignore
import poa_finalidades from '@/mixins/axios/poa_finalidades'

//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,                      z
    VuetablePagination,*/
    FuncionesHeader,
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  
        columnasd:[
            
            
           
            {
                tag:'clave',
                data:'clave',
                active:true
            },
            {
                tag:'funciones',
                data:'funciones',
                active:true
            },
           
        
              {
                tag:'select_sub',
                data:'select',
                active:false
            },
            /* {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },*/
           
        ],




        id:null as any,
        funciones:null as any,
clave:null as any,
      idfinalidades:0,
     poa_Subfuncionesdata:[] as any,
     
         
         
              poa_funcionesdata:[] as any,
              poa_finalidades:[]as any,
          
      
    }
  },
     mixins: [poa_funciones,poa_finalidades],
     validations: {
    
           clave: {
      required,
    },
 
     
           funciones: {
      required,
    },
 
           idfinalidades: {
      required,
    },
 
 
  },
  methods:{
       clearstate(){
this.$store.commit('SETPOAFUN',null);
//this.$store.commit('SETIFINA',null);
 this.$router.push('/mun/poas/conac/finalidades/funciones')
        },

        select(row){


           //this.secretaria_sel=row;
//this.departamentos=true;
 this.$store.commit('SETPOAFUN',row);
 this.$router.push('/mun/poas/conac/finalidades/funciones/subfunciones')
//this.getDataDepartamentos();

      
     },
      onChangeF(event){
//console.log(event.target.value)
this.getDataFinalidad(event.target.value);

},
       async getDataFinalidad(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_POA_FINALIDADES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_finalidades=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_POA_FUNCIONES(row).then(response => {

                    if (response != null) {

 this.poa_funcionesdata=this.poa_funcionesdata.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },

     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
          
                 this.clave=null;
                  this.funciones=null;
              
                 

        
    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_funciones_data').modal('show')
      },
seteditar(row){


 this.id=row.id;

                 this.clave=row.clave;
                  this.funciones=row.funciones;
                 
                 

            
          
 $('#ac_modal_funciones_data').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_POA_FUNCIONES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.poa_funcionesdata.push(response)

                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar indicador areas, refresque la pagina");

                    }    $("#ac_modal_funciones_data").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){

let data= await this.EDITAR_POA_FUNCIONES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Indicador Variable modificado exitosamente, refresque la pagina");
  this.poa_funcionesdata=this.poa_funcionesdata.filter(item => item.id !== dat.id);
 this.poa_funcionesdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Variables, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
     
           
          idfinalidades:this.$store.state.finalidad_sel.id,
                 clave:this.clave,
                funciones:this.funciones,
            idmunicipio:this.$store.state.user.usuario.id_municipio,

}
console.log(dat)
 this.$root.$emit('loading', true); 
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio,
 idfinalidades:this.$store.state.finalidad_sel.id,
};

let data= await this.GET_POA_FUNCIONES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_funcionesdata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

async getDataSubciones() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_POA_SUBFUNCIONES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_Subfuncionesdata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},




  },
  mounted(){
    this.getData();
    this.getDataFinalidad();
    
      //alert('10')
  }
})
export default class Home extends Vue {}

